import React from 'react';
import Form from '../components/form/Form';
import Swal from 'sweetalert2';
import membersForms from '../services/api/membersForms';
import { Checkbox, Button, TextArea, Input } from 'semantic-ui-react';
import { errorInput, textArea, formInput } from '../components/helpers';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from '../components/helpers/recaptchaUtils';
import SignatureCanvas from 'react-signature-canvas';
import CounselingDocuments from '../containers/counseling/counselingOfficialDoc';
import { CounselingContainer } from '../assets/styles/components/counseling';
import { RegistrationForm } from '../assets/styles/components/Registration';
import { shouldLockGuestIdentity } from '../components/helpers/guests/guestIdentity';

const CounselingForm = (props) => {
  const [Attendant, set_Attendant] = React.useState({});
  const [errorInputs, set_errorInputs] = React.useState({});
  const [sent, set_sent] = React.useState(false);
  const [sending, set_sending] = React.useState(false);
  const [secondStep, set_secondStep] = React.useState(false);
  const getCaptchaToken = useRecaptchaToken('counseling');
  const captchaRequired = isCaptchaRequired();
  const canvasSign = React.useRef(null);

  const verifyForm = () => {
    let mandatoryInputs = [
      'name',
      'lastName',
      'identification',
      'phone',
      'email',
      'gender',
      'address',
    ];

    let errorInputs = {};

    if (secondStep) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'sign',
          value: canvasSign.current && !canvasSign.current.isEmpty(),
        },
      });
    }

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: Attendant[input] },
      });
    });

    if (Attendant['identification'] && Attendant['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: Attendant['identification'].length >= 5,
        },
      });
    }

    if (Attendant['phone'] && Attendant['phone'].length <= 10) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'phone',
          value: Attendant['phone'].length >= 10,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  let sendForm = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    const signature = canvasSign.current;
    if (!signature || signature.isEmpty()) {
      set_errorInputs((prev) => ({ ...prev, sign: true }));
      return;
    }
    const sign = JSON.stringify(signature.toData().flat());

    set_sending(true);
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_sending(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    let body = { ...Attendant, sign, captcha };
    membersForms
      .newCounseling(body)
      .then((response) => {
        if (response.data.success) {
          set_sending(false);
          set_sent(true);
          Swal.fire({
            icon: 'success',
            title: '¡Se ha enviado correctamente!',
            text: 'Gracias por haberte registrado, en un período de 5 a 8 días te será asignado el consejero.',
          });
        } else {
          Swal.fire('Hubo un error, por favor intenta más tarde.');
        }
      })
      .catch((error) => {
        Swal.fire('Hubo un error, por favor intenta más tarde.');
      });
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    set_Attendant({ ...Attendant, [name]: value });
  };

  const handleCheckers = (name) => set_Attendant({ ...Attendant, [name]: !Attendant[name] });

  const formConsejeria = () =>
    !sent ? (
      <>
        <h1>Formulario Necesito Ayuda</h1>
        {!secondStep ? (
          <>
            <p>Llena la siguiente información y nos pondremos en contacto contigo.</p>
            {Object.values(errorInputs).includes(true) && !shouldLockGuestIdentity(Attendant) && (
              <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
            )}
            <Form
              Attendant={Attendant}
              handleInputs={handleInputs}
              errorInputs={errorInputs}
              showGender
              setAttendant={set_Attendant}
              setErrorInputs={set_errorInputs}
            />
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Dirección',
              name: 'address',
              value: Attendant.address || '',
              errorInputs,
            })}
            <div className="checks">
              <Checkbox
                label="¿Asistes actualmente a un grupo de Comunidad?"
                name="attendingGroup"
                toggle
                checked={Attendant.attendingGroup}
                onClick={() => handleCheckers('attendingGroup')}
              />
            </div>
            {textArea({
              TextArea,
              label: 'Por favor, escribe con detalle la ayuda que necesitas',
              name: 'counselingReason',
              handler: handleInputs,
              value: Attendant.counselingReason,
              errorInputs,
            })}
            {textArea({
              TextArea,
              label: 'Tienes alguna petición de Oración',
              name: 'toPray',
              handler: handleInputs,
              value: Attendant.toPray,
              errorInputs,
            })}
          </>
        ) : (
          <>
            <p>Revisa el siguiente documento, firmalo y presiona en enviar.</p>
            <CounselingDocuments
              Attendant={Attendant}
              canvasSign={canvasSign}
              signComponent={(name) => {
                if (name === 'user')
                  return (
                    <SignatureCanvas
                      penColor="black"
                      ref={canvasSign}
                      canvasProps={{
                        width: 300,
                        height: 200,
                        className: `sigCanvas  ${errorInputs['sign'] ? 'error' : ''}`,
                      }}
                    />
                  );
              }}
              errorInputs={errorInputs}
            />
            <p className="habeasdata">
              Al enviar aceptas el tratamiento de datos de Iglesia Comunidad Cristiana de Fe y
              Viento Fresco.
            </p>
            <Button onClick={(e) => sendForm(e)} primary disabled={sending}>
              Enviar
            </Button>
          </>
        )}
        {Object.values(errorInputs).includes(true) && (
          <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
        )}
        <Button
          onClick={(e) => {
            e.preventDefault();
            if (verifyForm()) return;
            set_secondStep(!secondStep);
          }}
          style={{ display: 'block', margin: '0 auto' }}
          disabled={sending}
        >
          {secondStep ? 'Regresa a corregir' : 'Continua'}
        </Button>
      </>
    ) : (
      <>
        <h1>¡Gracias por contactarnos {Attendant.name}!</h1>
        <p>Muy pronto estaremos en contacto contigo.</p>
      </>
    );
  return (
    <CounselingContainer>
      <RegistrationForm>
        <p>Hola</p>
        <p>Este formulario esta temporalmente cerrado.</p>
        <p>Por favor, escríbenos si tienes alguna pregunta.</p>
        {false && formConsejeria()}
      </RegistrationForm>
    </CounselingContainer>
  );
};

export default CounselingForm;
